/**
 * PollingIndicator Molecule
 * Shows last updated time and refresh button
 */

import { RefreshCw } from 'lucide-react';
import { Button } from '@/core/components/ui/button';
import { formatRelativeTime } from '../../utils/currency-utils';
import { cn } from '@/core/lib/utils';

interface PollingIndicatorProps {
  lastUpdated: Date | null;
  isRefreshing?: boolean;
  onRefresh?: () => void;
  showLabel?: boolean;
}

export function PollingIndicator({
  lastUpdated,
  isRefreshing = false,
  onRefresh,
  showLabel = true,
}: PollingIndicatorProps) {
  return (
    <div className="flex items-center gap-2 text-sm text-gray-500">
      {showLabel && lastUpdated && (
        <span>
          Last updated: {formatRelativeTime(lastUpdated)}
        </span>
      )}

      {/* Live indicator dot */}
      <span className="flex items-center gap-1">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
        </span>
        <span className="text-xs text-green-600 font-medium">Live</span>
      </span>

      {onRefresh && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onRefresh}
          disabled={isRefreshing}
          className="h-8 w-8 p-0"
        >
          <RefreshCw
            className={cn(
              'h-4 w-4',
              isRefreshing && 'animate-spin'
            )}
          />
        </Button>
      )}
    </div>
  );
}
